var exports = {
  "tU": "specialOffersPlacementContainer__ZXBqR",
  "f0": "listRow__ZXBqR",
};

module.exports = exports;
